import { createFileRoute } from "@tanstack/react-router";
import { SiteFooter, SiteHeader } from "@/components/tools/ToolShell";

export const Route = createFileRoute("/pt-br/contact")({
  head: () => ({
    meta: [
      { title: "Contato — Picamini.online" },
      {
        name: "description",
        content: "Fale conosco no Picamini.online. Envie dúvidas, sugestões de ferramentas ou suporte técnico.",
      },
    ],
    links: [
      { rel: "canonical", href: "https://picamini.online/pt-br/contato" },
      { rel: "alternate", hrefLang: "en", href: "https://picamini.online/contact" },
      { rel: "alternate", hrefLang: "es", href: "https://picamini.online/es/contacto" },
      { rel: "alternate", hrefLang: "de", href: "https://picamini.online/de/kontakt" },
      { rel: "alternate", hrefLang: "pt-BR", href: "https://picamini.online/pt-br/contato" },
      { rel: "alternate", hrefLang: "x-default", href: "https://picamini.online/contact" },
    ],
  }),
  component: PtBrContactPage,
});

function PtBrContactPage() {
  return (
    <div className="min-h-screen bg-background flex flex-col font-sans">
      <SiteHeader lang="pt-BR" />

      <main className="flex-1 py-12 mx-auto max-w-3xl px-4 sm:px-6 lg:px-8 space-y-6">
        <h1 className="text-3xl font-extrabold text-foreground">Entre em Contato</h1>
        <p className="text-base text-muted-foreground leading-relaxed">
          Tem alguma dúvida, encontrou algum problema ou gostaria de sugerir uma nova ferramenta para o Picamini.online? Adoramos receber o feedback de nossos usuários!
        </p>

        <div className="surface-card p-6 rounded-2xl border bg-card space-y-4">
          <p className="font-bold text-foreground">E-mail de Suporte:</p>
          <a href="mailto:support@picamini.online" className="text-primary font-bold hover:underline">
            support@picamini.online
          </a>
          <p className="text-xs text-muted-foreground">Respondemos a todas as mensagens enviadas em até 48 horas úteis.</p>
        </div>
      </main>

      <SiteFooter lang="pt-BR" />
    </div>
  );
}
